export default __webpack_public_path__ + "static/media/Payout.d384ca61.png";